module.exports = __webpack_public_path__ + "static/media/insta1.8872aee7.png";